import { render, staticRenderFns } from "./InterestModal.vue?vue&type=template&id=5cf71f60&scoped=true&"
import script from "./InterestModal.vue?vue&type=script&lang=js&"
export * from "./InterestModal.vue?vue&type=script&lang=js&"
import style0 from "./InterestModal.vue?vue&type=style&index=0&id=5cf71f60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf71f60",
  null
  
)

export default component.exports